import { getAPIBaseUrl } from "../../../../utils/constants";

export function getInitialUserImagePreview(profileData) {
  const userImage = profileData?.user?.user_image;

  return userImage ? `${getAPIBaseUrl()}/${userImage}` : userImage;
}

export function isValidImageFile(file) {
  return Boolean(file?.type?.startsWith("image/"));
}
